import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { PublicLayout } from "@/components/layout/public-layout";
import { Button } from "@/components/ui/button";

export function NotFoundPage() {
  return (
    <PublicLayout>
      <Helmet>
        <title>Page not found · DealerDog</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <section className="max-w-lg mx-auto px-4 sm:px-6 pt-16 pb-20 text-center">
        <p className="text-sm font-medium text-gray-500">404</p>
        <h1 className="mt-2 text-2xl sm:text-3xl font-bold text-gray-900">Page not found</h1>
        <p className="mt-3 text-gray-600">
          That link does not exist or may have moved. Head back to the home page or contact us if you
          need help.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Button asChild>
            <Link to="/">Back to home</Link>
          </Button>
          <Button asChild variant="outline">
            <a href="mailto:andrew@dealerdog.co">Contact DealerDog</a>
          </Button>
        </div>
      </section>
    </PublicLayout>
  );
}
